import { useState } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { FAQS } from './consts'
import { FAQItem } from './components/FAQItem'

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const { t } = useLocalization()

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section id="faq" className="w-full scroll-mt-24 bg-white">
      <Column className="mx-auto w-full max-w-6xl items-center gap-8">
        <h2 className="text-center text-4xl font-normal text-neutral-800 !leading-tight md:text-6xl md:!leading-[1.1]">
          {t('Frequently asked questions', 'Vanliga frågor')}
        </h2>

        <Column className="w-full max-w-3xl gap-0">
          {FAQS.map((faq, index) => (
            <FAQItem
              key={index}
              faq={faq}
              isOpen={openIndex === index}
              onToggle={() => toggleFAQ(index)}
            />
          ))}
        </Column>
      </Column>
    </section>
  )
}
